import * as React from "react"
import { Grid } from "@mui/material"
import {string, object, array} from "yup";
import { DrawerSeeker, TextFieldSeeker, SelectSeeker, TagFieldSeeker } from "@ui-seeker/core"
import { useAppToast, useValidatorSeeker } from "@ui-seeker/app"
import { isEmpty } from '@ui-seeker/utils'

import {digitalShelfReportFormIsOpen} from "../@signals";
import { OPTIONS_FREQUENCY } from "./constants"
import {useDigitalShelfReportForm} from "../@hooks";


export default function DigitalShelfReportFormDrawer() {
    const { showToast } = useAppToast()
    const { handleSendToBack, nameReport, frequency, emailsReport, resetFormData } = useDigitalShelfReportForm()

    const validatorData = useValidatorSeeker({
        nameReport: nameReport.value,
        frequency: frequency.value,
        emailsReport: emailsReport.value,
    }, object({
        nameReport: string().required('Report name must be provided'),
        frequency: string().required('Frequency must be provided'),
        emailsReport: array().min(1, 'At least 1 email is required'),
    }))

    if (!digitalShelfReportFormIsOpen.value) return <></>

    return <DrawerSeeker
        isOpen={digitalShelfReportFormIsOpen.value}
        controller={() => {
            digitalShelfReportFormIsOpen.value = false
            resetFormData()
        }}
        title={`Create New Product Page Details Report`}
        width="40%"
        successProps={{ onClick: isEmpty(validatorData.errors)
                ? handleSendToBack
                : () => showToast.warning('Please ensure all mandatory fields are completed ')
        }}
    >
        <Grid container spacing={3}>
            <Grid item xs={12}>
                <TextFieldSeeker
                    error={validatorData.errors?.nameReport}
                    label="Report Name"
                    size="small"
                    fullWidth
                    value={nameReport.value}
                    onChange={e => nameReport.value = e.target.value}
                    icon="pen-to-square"
                />
            </Grid>

            <Grid item xs={12}>
                <SelectSeeker
                    error={validatorData.errors?.frequency}
                    label="Frequency"
                    fullWidth
                    options={OPTIONS_FREQUENCY}
                    value={frequency.value}
                    onChange={e => frequency.value = e.target.value}
                />
            </Grid>

            <Grid item xs={12}>
                <TagFieldSeeker
                    error={validatorData.errors?.emailsReport}
                    value={emailsReport.value}
                    fullWidth
                    onChange={e => emailsReport.value = e }
                    label="Emails"
                    placeholder="Enter to add emails"
                />
            </Grid>

        </Grid>
    </DrawerSeeker>
}